import React, {useState, useCallback, useEffect, useMemo} from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { Tooltip, Tag, message, Table, InputNumber } from 'antd'
import b_ from 'b_'
import ImageViews from '../../Components/ImageViews'
import LinksViews from '../../Components/LinksViews'
import ExpandViews from '../../Components/ExpandViews'
import useStorageState from '../../Utils/useStorageState'
import PrintProxiesStatus from '../../Components/Prints/PrintProxiesStatus'
import TableSettings from '../../Utils/TableSettings'
import PrintDate from '../../Components/Prints/PrintDate'

const b = b_.lock('VirtualMachinesTable')

function TransactionsTable({
                      list,
                      tableOnChange,
                      pagination,
                      loading,
                      afterUpdate,
                      onFilter,
                      filters,
                      selected,
                      onSelectChange,
                      handleSave,
                      fieldsChange
                    }) {

  
  const GetColumns = useCallback(() => {

    return [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        width: 52,
        // sorter: (a, b) => a.id - b.id,
        render: (_, rec) => <PrintDate withTime date={rec.date} />
      },
      {
        title: 'Number',
        dataIndex: 'number',
        key: 'number',
        width: 70,
        // sorter: (a, b) => a.groupName.localeCompare(b.groupName),
      },
      {
        title: 'Total',
        dataIndex: 'total',
        key: 'total',
        width: 70,
        // sorter: (a, b) => a.name.localeCompare(b.name),
      },
      {
        title: 'Paid with',
        dataIndex: 'paidWith',
        key: 'paidWith',
        width: 120,
        sorter: (a, b) => a - b,
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: 80,
        sorter: (a, b) => a - b,
      },
      {
        title: 'Item ID',
        dataIndex: 'itemId',
        key: 'itemId',
        width: 80,
        // sorter: (a, b) => a - b,
      },
      {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        width: 80,
        sorter: (a, b) => a - b,
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        align: "center",
        width: 80,
        // sorter: (a, b) => a.status.localeCompare(b.status),
      },
      {
        title: 'Details',
        dataIndex: 'details',
        key: 'details',
        width: 80,
        sorter: (a, b) => a - b,
      },
      {
        title: 'Gift for',
        dataIndex: 'giftFor',
        key: 'giftFor',
        width: 80,
        sorter: (a, b) => a - b,
      },
      {
        title: 'Code',
        dataIndex: 'code',
        key: 'code',
        width: 80,
        // sorter: (a, b) => a - b,
      },
    ]; 
  }, [filters, list])

  const [columns, setColumns] = useState(GetColumns());

  const [Checkboxs, setCheckbox] = useState([]);

  const [AllCheckbox, setAllCheckbox] = useStorageState('transcations_table', {
    checkedList: Checkboxs,
    indeterminate: false,
    checkAll: true,
});

  const onChangeCheckList = useCallback((checkedList) => {
    setAllCheckbox({
        checkedList,
        indeterminate: !!checkedList.length && checkedList.length < columns.length,
        checkAll: checkedList.length === columns.length,
    });
}, [Checkboxs]);

useEffect(() => {
  let allCheckList = []
  if (list.length && !Checkboxs.length) {
      GetColumns().forEach((e) => {
          allCheckList.push(e[Object.keys(e)[1]])
          setCheckbox(allCheckList)
      })
  }
}, [list, AllCheckbox, Checkboxs.length, GetColumns])

useEffect(() => {
  if (AllCheckbox.checkAll) {
      setAllCheckbox({
          checkedList: GetColumns().map(e => e.title),
          indeterminate: false,
          checkAll: true,
      })
  }
}, [AllCheckbox.checkAll, GetColumns, setAllCheckbox])

  const onChangeCheckAll = useCallback((e) => {
    setAllCheckbox({
        checkedList: (e.target.checked && columns.map(e => e.title)) || [],
        indeterminate: false,
        checkAll: e.target.checked,
    });
}, [Checkboxs]);

  useEffect(() => {
      setColumns(GetColumns())
  }, [list, loading, filters, GetColumns])

  const columnsFilter = columns.filter(e => AllCheckbox.checkedList.indexOf(e.title) !== -1);
  const loader = loading

  
  return <Table
            rowKey={(record) => `${record.id}`}
            className={b()}
            bordered
            dataSource={list}
            scroll={{ x: 'max-content' }}
            size="middle"
            onChange={(a, b, c) => tableOnChange(a, b, c)}
            onFilter={onFilter}
            pagination={pagination}
            loading={loader}
            columns={columnsFilter}
            title={() => <TableSettings
              onChangeCheckAll={onChangeCheckAll}
              allChecks={AllCheckbox}
              Checkboxs={AllCheckbox.checkedList}
              TableColumn={() => GetColumns()}
              setCheckbox={onChangeCheckList}
          />}
            rowClassName={() => b('lock')}
            rowSelection={{
              selectedRowKeys: selected,
              onChange: onSelectChange,
            }}
  />
}

export default TransactionsTable;
